import { render, staticRenderFns } from "./mastergo.vue?vue&type=template&id=508c8646&"
import script from "./mastergo.vue?vue&type=script&lang=js&"
export * from "./mastergo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports